export const SocialMediaList = [
    {
        id:1,
        title:"HKC on Social Media",
        folderTitle:"/images/socialmedia/",
        images:[
            {image:"1.jpg",link:"https://www.facebook.com/holykrishnacollege"},
            {image:"2.jpg",link:"https://www.instagram.com/hkc_a_cbse_school/"},
            {image:"3.jpg",link:"https://www.youtube.com/@holykrishnascollege115/videos"}
        ]
    },
     

]